export const BROADCAST_SCREEN_UPDATE = `
  mutation BroadcastScreenUpdate($input: BroadcastScreenUpdateInput!) {
    broadcastScreenUpdate(input: $input) {
      message
    }
  }
`;